import type { ChipProps } from '@mui/material';

import type { JiraSubtask } from '../../hooks/useJiraApi';

/** Maps an Atlassian status category to the corresponding MUI chip colour. */
export const statusChipColor = (
    statusCategory: JiraSubtask['statusCategory'],
): NonNullable<ChipProps['color']> => {
    switch (statusCategory) {
        case 'done':
            return 'success';
        case 'indeterminate':
            return 'info';
        default:
            return 'default';
    }
};
